import React from "react";
import { BlockText } from "./PageContent/BlockText";
export default function TextWithBg(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:pl-14 md:pr-36 lg:px-14 pb-3 md:py-16 lg:py-24 pt-12 relative bg-gray-30 white-triangle-top content-text-bg"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-3xl mx-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:flex w-full lg:gap-x-14 items-start mb-11 md:mb-12 lg:mb-0"
    }, /*#__PURE__*/ React.createElement(BlockText, {
        markup: props.markup
    }))));
}
